// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3M_DT","content":"ManualTimeModal_content__1BRot"};